import { create } from 'zustand'

import { logger } from '@/utils/logger';
export const useAuthStore = create((set) => ({
  user: null,
  userType: null, // 'admin' or 'customer'
  isAuthenticated: false,
  isLoading: true, // Initial loading state
  isRedirecting: false, // Flag to prevent error displays during logout redirect

  setAuth: (email, userType) => {
    set({ user: { email }, userType, isAuthenticated: true, isLoading: false, isRedirecting: false })
  },

  clearAuth: () => {
    set({ user: null, userType: null, isAuthenticated: false, isLoading: false, isRedirecting: false })
  },

  setRedirecting: () => {
    set({ isRedirecting: true })
  },

  logout: async () => {
    try {
      await fetch('/api/v1/auth/logout', {
        method: 'POST',
        credentials: 'include' // Send cookies
      })
    } catch (error) {
      logger.error('Logout error:', error)
    }
    set({ user: null, userType: null, isAuthenticated: false, isLoading: false, isRedirecting: false })
  },
}))
